<ng-container *ngrxLet="packingListResource$ as packingListResource">
  <div class="erow" [class.last]="isLast" *ngIf="item">
    <div class="etext">
      <div class="item">
        <img
          class="eimage"
          src="/img/ClosureImages/InnerPacking.png"
          alt="InnerPacking"
        />
        <label
          >{{ item.CountOfPackagings }}&nbsp;{{
            item.AlternativePackagingType
          }}</label
        >
        <span class="ch-ggs-web-suite-packing-cmds ml-auto" *ngIf="!hideIcons">
          <button
            type="button"
            class="btn"
            (click)="edit()"
            [title]="packingListResource['EditPackage']"
          >
            <i
              class="ifc-custom ifc-pencil d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="btn"
            (click)="copyPackage()"
            [title]="packingListResource['CopyPackage']"
          >
            <i
              class="ifc-custom ifc-content_copy d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            type="button"
            class="btn"
            (click)="removePackage()"
            [title]="packingListResource['RemoveDangerousGoodButton']"
          >
            <i
              class="ifc-custom ifc-bin d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
          <button
            *ngIf="showPrintLabel"
            type="button"
            class="btn"
            (click)="printLabel()"
            [title]="packingListResource['PrintLabel']"
          >
            <i
              class="ifc-custom ifc-price-tag d-flex align-items-center justify-content-center"
              aria-hidden="true"
            ></i>
          </button>
        </span>
      </div>
      <span class="shipping-name">{{
        item.DangerousGood?.DefaultShippingExpression
      }}</span>
    </div>
  </div>
</ng-container>
